export default "__VITE_ASSET__BbnIT4ZH__"